import { FrozeCloseList } from './FrozeCloseList/FrozeCloseList'
import { OrderLineList } from './OrderLineList'
import { AppScrollWrapperNew } from 'widgets/AppScrollWrapper/AppScrollWrapper'
import {
  IPlanMenuCloseOrderDetailDto,
  IPlanMenuCloseOrdersRequest,
} from 'core/api/dto/PlanMenuCloseDto'
import { AddDishBlock } from './DishItem/AddDishBlock'

export interface IDishBlockProps {
  orderDetail?: IPlanMenuCloseOrderDetailDto | undefined
  orderId: string | null
  onClick?: () => void
  pageParams: IPlanMenuCloseOrdersRequest | null
  width: number
  setIsShowPopup: () => void

  dimensionId: string | null
  dishId: string | null
}

export const DishBlock = ({
  onClick,
  width,
  orderId,
  orderDetail,
  pageParams,
  setIsShowPopup,

  dimensionId,
  dishId,
}: IDishBlockProps) => {
  return (
    <div className="row columns-scroll-row">
      <div
        className={`width-${width <= 1024 ? (width <= 768 ? 100 : 33) : 33}`}
      >
        {orderDetail && orderId && (
          <OrderLineList
            pageParams={pageParams}
            setIsShowPopup={() => {}}
            isAll={false}
          />
        )}
      </div>

      <div
        className={`width-${width <= 1024 ? (width <= 768 ? 100 : 20) : 20}`}
      >
        {orderDetail && orderId && dishId && (
          <FrozeCloseList
            pageParams={{
              ...pageParams,
            }}
            withTaskAddButton={false}
          />
        )}
      </div>
      <div
        className={`width-${width <= 1024 ? (width <= 768 ? 100 : 45) : 45}`}
      >
        <AppScrollWrapperNew theme="dropdown">
          {orderDetail && orderId && dimensionId && (
            <AddDishBlock
              orderDetail={orderDetail}
              pageParams={{
                ...pageParams,
              }}
              onClick={setIsShowPopup}
            />
          )}
        </AppScrollWrapperNew>
      </div>
    </div>
  )
}